export const omniaTheme = {
  colors: {
    // Primary purple — used sparingly: logo, location pin, agency markers, score-bar fills,
    // sales-process active phase, location callout vertical bar.
    primary: '#2F1073',
    primaryDark: '#1F0A52',
    primaryDeep: '#160740',

    // Progressive purple shades for chart bars and timeline depth
    purple100: '#E8E5F4',
    purple300: '#B5AFD9',
    purple500: '#5A4D9E',
    purple700: '#2F1073',
    purple900: '#1F0A52',

    // Neutrals — the workhorses (~85% of every page). `black` is deliberately
    // NOT pure #000000 — strokes and headings use the brand's dark purple-tinted
    // near-black so lines never carry the harshness of pure black.
    black: '#2F2252',
    text: '#1F1F1F',
    textMuted: '#6B7280',
    textLabel: '#9CA3AF',

    // Brand structure: the cover uses a GRAY page with WHITE cards; the rest
    // of the report uses a WHITE page with light-gray (`#f0f2f4`) cards.
    pageBg: '#FFFFFF',
    cardBg: '#f0f2f4',
    coverPageBg: '#f0f2f4',
    coverCardBg: '#FFFFFF',

    // All hairline strokes use the brand dark color (#2F2252) with a small
    // amount of transparency so they read as thin lines rather than hard rules.
    border: 'rgba(47, 34, 82, 0.15)',
    borderStrong: 'rgba(47, 34, 82, 0.25)',
    strokeLine: '#2F2252',

    white: '#FFFFFF',
    danger: '#DC3545',
  },
  fonts: {
    // Sequel Sans — display font, self-hosted under apps/popety-io-app/public/fonts/omnia/
    heading: "'Sequel Sans', 'Inter', system-ui, sans-serif",
    body: "'Sequel Sans', 'Inter', system-ui, sans-serif",
    // Roboto Condensed — secondary for UPPERCASE labels
    label: "'Roboto Condensed', 'Roboto', system-ui, sans-serif",
  },
  fontSizes: {
    micro: '8px',
    label: '10px', // Roboto Condensed UPPERCASE labels with 0.12em tracking
    small: '11px',
    body: '12px',
    medium: '14px',
    large: '18px',
    xlarge: '22px',
    huge: '32px',
    display: '56px', // Cover headline
  },
  fontWeights: {
    light: 300, // Sequel Sans Light — the brand's default display weight
    normal: 400, // Sequel Sans Roman
    medium: 500, // Sequel Sans Book
    bold: 700,
  },
  letterSpacing: {
    tight: '-0.01em', // Display headlines
    normal: '0',
    wide: '0.12em', // Roboto Condensed UPPERCASE labels
  },
  spacing: {
    pageMargin: '20mm',
    sectionGap: '32px',
    contentGap: '24px',
    cardPadding: '20px',
    smallGap: '12px',
    tinyGap: '8px',
  },
  borderRadius: {
    // Omnia is FLAT — no rounded corners anywhere except the location-pin marker.
    none: '0',
    pin: '50% 50% 50% 50% / 60% 60% 40% 40%',
  },
  shadows: {
    // Omnia uses NO shadows. White-on-gray contrast does the elevation work.
    none: 'none',
  },
  print: {
    pageSize: 'A4',
    pageWidth: '210mm',
    pageHeight: '297mm',
  },
}

export type OmniaTheme = typeof omniaTheme
